import { useState } from 'react';
import { useLazyLaboratoryResultsQuery } from '../../../graphql/graphql';
import { useAppContext } from '../../../Services/AppContext';

export default function useLaboratoryResults() {
	const { workplaceId } = useAppContext();
	const [getLaboratoryResultsQuery, { data, isLoading }] =
		useLazyLaboratoryResultsQuery();
	const [page, setPage] = useState(1);
	const getLaboratoryResults = (filter?: object) => {
		getLaboratoryResultsQuery({
			where: {
				...filter,
				workplaceId: workplaceId,
			},
			pagination: {
				skip: (page - 1) * 20,
			},
		});
	};

	const getNextPage = () => {
		setPage(prev => prev + 1);
	};

	return { getLaboratoryResults, getNextPage, data, isLoading, page, setPage };
}
